// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oA-d","newExpiryDate":"styles_newExpiryDate__SUadn","footer":"styles_footer__3q10W"};